import { render, staticRenderFns } from "./smartSwitch.vue?vue&type=template&id=38bf022e&scoped=true&"
import script from "./smartSwitch.vue?vue&type=script&lang=js&"
export * from "./smartSwitch.vue?vue&type=script&lang=js&"
import style0 from "./smartSwitch.vue?vue&type=style&index=0&id=38bf022e&lang=scss&scoped=true&"
import style1 from "./smartSwitch.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bf022e",
  null
  
)

export default component.exports